import { render, staticRenderFns } from "./IndagineEpidemiologicaRosoliaCongenitaViewComponent.vue?vue&type=template&id=1c9e1a63"
import script from "./IndagineEpidemiologicaRosoliaCongenitaViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaRosoliaCongenitaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports